<div class="location-list-container">
  <div class="location-list-header">
    <h2 class="location-list-title">Choose a location</h2>
    <!-- TODO(V2): search/filter controls -->
  </div>
  
  <div class="location-divider"></div>

  <div class="location-cards">
    <ng-container *ngFor="let loc of (locations || []); trackBy: trackById; let last = last">
      <app-location-card
        [location]="loc"
        [active]="loc.Id === selectedId"
        [newestLocationId]="newestLocationId"
        (click)="select.emit(loc.Id)">
      </app-location-card>
      <div class="location-divider" *ngIf="!last"></div>
    </ng-container>
  </div>
</div>
